import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseCoreChip from 'frontcore/views/chips/chip/views/base/BaseCoreChip.vue'
import { ChipType } from 'frontcore/views/chips/chip/types'

type Props = {
  deletable?: boolean
  dataTest?: string
  disabled?: boolean
  iconName?: string
  imageSrc?: string
  label: string
  selected: boolean
}
type Emits = {
  (e: 'click', event: React.MouseEvent<HTMLElement, MouseEvent>): void
  (e: 'handlerClick', event: React.MouseEvent<HTMLElement, MouseEvent>): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CoreChipInput',
  props: {
    deletable: { type: Boolean, default: false },
    dataTest: { default: 'core-chip-input' },
    disabled: { type: Boolean, default: false },
    iconName: {},
    imageSrc: {},
    label: {},
    selected: { type: Boolean, default: false }
  },
  emits: ["click", "handlerClick"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

const onClick = (event: React.MouseEvent<HTMLElement, MouseEvent>): void => {
  emit('click', event)
}

const onHandlerClick = (event: React.MouseEvent<HTMLElement, MouseEvent>): void => {
  emit('handlerClick', event)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseCoreChip, {
    chipType: _unref(ChipType).INPUT,
    deletable: _ctx.deletable,
    dataTest: _ctx.dataTest,
    disabled: _ctx.disabled,
    iconName: _ctx.iconName,
    imageSrc: _ctx.imageSrc,
    label: _ctx.label,
    selected: _ctx.selected,
    onClick: onClick,
    onHandlerClick: onHandlerClick
  }, null, 8, ["chipType", "deletable", "dataTest", "disabled", "iconName", "imageSrc", "label", "selected"]))
}
}

})